import * as angular from 'angular';
import CoreModule from './../core/core.module';
import GeographyService from './geography.service';

export default angular
  .module('geography', [
    CoreModule,
  ])
  .service('GeographyService', GeographyService)
  .name;



// WEBPACK FOOTER //
// ./src/app/geography/geography.module.js